var libraryAccordions = document.querySelectorAll('.ingredient-library-items-list-item-header');
var libraryAccordionsGroup = document.querySelectorAll('.ingredient-library-items-list-items-group');

for (var i = 0; i < libraryAccordionsGroup.length; i++) {
  var libraryAccordionsGroupFirstItem = libraryAccordionsGroup[i].querySelectorAll('.ingredient-library-items-list-item ')[0];
  var libraryFirstAccordionPanel = libraryAccordionsGroupFirstItem.querySelector('.ingredient-library-items-list-item-content');
  libraryFirstAccordionPanel.style.maxHeight = libraryFirstAccordionPanel.scrollHeight + "px";
}

for (var i = 0; i < libraryAccordions.length; i++) {
  
  var libraryAccordionPanel = libraryAccordions[i].nextElementSibling;
  
  
  libraryAccordions[i].addEventListener("click", function() {
    this.classList.toggle("active");
    this.closest('.ingredient-library-items-list-item').classList.toggle('is-open');

    var libraryAccordionPanel = this.nextElementSibling;
    if (libraryAccordionPanel.style.maxHeight) {
      libraryAccordionPanel.style.maxHeight = null;
    } else {
      libraryAccordionPanel.style.maxHeight = libraryAccordionPanel.scrollHeight + "px";
    }
  });
}